<template>
  <div id="contenedor-eliminar-minuta">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Minuta </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la Minuta? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{minutaEliminar.numero}}
          </span>
        </v-row>
         <v-row>
          <span> <cortar-texto
          :texto="minutaEliminar.objetivo">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarMinuta"
          :disabled="enviandoFormulario || tieneDependencias || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import mixMinutas from './mixMinutas';

export default {
  name: 'ContenedorEliminarMinuta',
  props: {
    minutaEliminar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixMinutas],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarMinuta() {
      this.mixEliminarMinuta();
    },
  },
  computed: {
    tieneDependencias() {
      if (this.minutaEliminar.acuerdos.length > 0
      || this.minutaEliminar.participantes.length > 0) return true;
      return false;
    },
  },
};
</script>
